import { useState } from "react";

export const useDeleteConfirm = (onDelete) => {
  const [confirmModalData, toggleConfirmModal] = useState<{
    show: boolean;
    id: number | string;
  }>({
    show: false,
    id: 0,
  });

  const closeConfirmModal = () => {
    toggleConfirmModal({ show: false, id: 0 });
  };

  const confirmDelete = () => {
    const id = confirmModalData.id;
    closeConfirmModal();
    onDelete(id);
  };

  return {
    confirmModalData,
    toggleConfirmModal,
    closeConfirmModal,
    confirmDelete,
  };
};
